import { useRedirect, useStore, useNotify, useRefresh } from 'react-admin';
import * as React from "react";
import { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import { Card, CardContent, Typography } from '@mui/material';
import { Title } from 'react-admin';

const Redirect = () => {
    const updateByReload = true;
    const redirect = useRedirect();
    const notify = useNotify();
    const refresh = useRefresh();
    const [searchParams,] = useSearchParams();
    const [storedRemain, setStoredRemain] = useStore('my.redirect.remain');
    const [storedCount, setStoredCount] = useStore('my.redirect.count');
    const [text, setText] = useState('Please wait a moment')

    useEffect(() => {
        if (storedRemain) {
            const { to, notice, noticeType } = storedRemain;
            setStoredRemain(null);
            setText(`Redirect to ${to}`);
            redirect(to);
            if (notice) {
                notify(notice, { type: noticeType })
            }
            return;
        }

        const to = searchParams.get('to');
        const notice = searchParams.get('notice');
        const noticeType = searchParams.get('noticeType');
        if (searchParams.get('update') !== null) {
            if (!updateByReload) {
                setStoredCount(storedCount + 1);
                refresh();
            } else {
                setStoredRemain({to, notice, noticeType});
                window.location.reload();
                return;
            }
        }

        setText(`Redirect to ${to}`)
        redirect(to);
        if (notice) {
            notify(notice, { type: noticeType })
        }
    }, [])

    return (
        <Card sx={{padding: '20px', marginTop: 2}}>
            <Title title="DeepBlock" />
                <CardContent>
                    <Typography gutterBottom>
                        {text}
                    </Typography>
                </CardContent>
        </Card>
    );
};

export default Redirect;
